import React, { useState } from "react";

import { GatsbyImage, getImage } from "gatsby-plugin-image";

import * as classes from "./ProductImages.module.css";

const ProductImages = (props) => {
  const [currIndex, setCurrIndex] = useState(0);

  const activeIndexHandler = (event) => {
    setCurrIndex(event.currentTarget.getAttribute("data-index"));
  };

  return (
    <div className={classes.productImagesContainer}>
      <div className={classes.imageMainContainer} key={currIndex}>
        <GatsbyImage
          image={getImage(props.images[currIndex].localFile.childImageSharp)}
          alt="lookbook-main-picture"
        />
      </div>

      <div className={classes.imageThumbContainer}>
        {props.images.map((image, i) => (
          <div className={classes.thumbnail} key={i}>
            <GatsbyImage
              image={getImage(image.localFile.childImageSharp)}
              alt="lookbook-picture"
              id={image.localFile.id}
              data-index={i}
              onClick={activeIndexHandler}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductImages;
